import React from "react";
import {Container} from "react-bootstrap";
import SalesFilterHeader from "../../Components/Statistics/SalesFilterHeader.jsx";
import useSalesFilters from "../../Components/Statistics/useSalesFilters.js";
import DetailDataGrid from "../../Components/Statistics/DetailDataGrid.jsx";

/**
 * Artikel - die bestehende Detailtabelle je Artikel bzw. Übernummer, seit
 * August 2026 eine eigene Unterseite (siehe StatisticsController::artikel()).
 * Ehemals der "Detailtabelle"-Reiter der Verkaufsstatistik.
 */
export default function StatisticsArtikel() {
    const salesFilters = useSalesFilters();
    const {filters, groupOptions, level} = salesFilters;

    return (
        <Container fluid className="pt-2 pb-4">
            <SalesFilterHeader title="Artikel" salesFilters={salesFilters}>
                <DetailDataGrid filters={filters} groupOptions={groupOptions} level={level} />
            </SalesFilterHeader>
        </Container>
    );
}
